export const MIN_SHOP_DOMAIN_LENGTH = 3;
export const MAX_SHOP_DOMAIN_LENGTH = 32;
export const MAX_USERNAME_LENGTH = 64;
export const MIN_SHOP_NAME_LENGTH = 2;
export const MAX_SHOP_NAME_LENGTH = 64;
export const MAX_SHOP_SOCIAL_NETWORK_LENGTH = 64;
export const MAX_PRODUCT_NAME_LENGTH = 64;
export const MAX_PRODUCT_BADGE_LENGTH = 16;
export const MAX_PRODUCT_SUMMARY_LENGTH = 280;
export const MIN_PRODUCT_STOCK = 0;
export const MAX_PRODUCT_STOCK = 10000000;
export const MIN_PRODUCT_PRICE = 0;
export const MAX_PRODUCT_PRICE = 10000000;
export const MAX_PRODUCT_IMAGES = 6;
export const MAX_SHOP_ABOUT_US_LENGTH = 600;
export const MAX_SHOP_LOCATION_LENGTH = 600;
export const MAX_CHAT_MESSAGE_LENGTH = 512;
export const MAX_EMAIL_LENGTH = 96;
export const MAX_COLLECTION_NAME_LENGTH = 64;
export const MAX_CHAT_WELCOME_MESSAGE_LENGTH = 140;
export const MAX_ORDER_DETAILS_ADDITIONAL_NOTES_LENGTH = 560;
export const MAX_CUSTOM_PAYMENT_MESSAGE_LENGTH = 512;
export const MAX_CUSTOM_SHIPPING_MESSAGE_LENGTH = 512;
export const MAX_STORE_PICKUP_ADDITIONAL_MESSAGE_LENGTH = 512;
export const MAX_SHIPPING_ADDRESS_LENGTH = 96;
export const MAX_SHIPPING_CITY_LENGTH = 64;
export const MAX_SHIPPING_PROVINCE_LENGTH = 64;
export const MAX_SHIPPING_ZIPCODE_LENGTH = 16;
export const MAX_BUYER_NATIONAL_ID_LENGTH = 32;
export const MAX_BUYER_BILLING_ADDRESS_LENGTH = 96;
export const MAX_BUYER_FIRSTNAME_LENGTH = 48;
export const MAX_BUYER_LASTNAME_LENGTH = 48;
export const MAX_BUYER_COMPANY_NAME_LENGTH = 64;
export const MAX_BUYER_COMPANY_TAX_ID_LENGTH = 32;
export const MAX_BUYER_COMPANY_ZIPCODE_LENGTH = 16;
export const MAX_BLOCK_IMAGE_TEXT_LENGTH = 128;
export const MAX_BLOCK_IMAGE_LINK_LENGTH = 128;
export const MAX_BLOCK_CAROUSEL_NUMER_OF_IMAGES = 5;
